import { SecureStorage } from '@aparajita/capacitor-secure-storage'

import { BIOMETRIC_ENABLED_KEY } from '@/constants/authKeys'
import { Logger } from '@/lib/logger'

const logger = new Logger('biometricUtils')

export const biometricUtils = {
  async isEnabled(): Promise<boolean> {
    try {
      const value = (await SecureStorage.get(BIOMETRIC_ENABLED_KEY)) as string | null
      return value === 'true'
    } catch {
      return false
    }
  },

  async setEnabled(enabled: boolean): Promise<void> {
    try {
      await SecureStorage.set(BIOMETRIC_ENABLED_KEY, enabled ? 'true' : 'false')
    } catch (error) {
      logger.error('Failed to set biometric enabled', error)
    }
  },

  async clear(): Promise<void> {
    try {
      await SecureStorage.remove(BIOMETRIC_ENABLED_KEY)
    } catch (error) {
      logger.error('Failed to clear biometric key', error)
    }
  },

  async hasPreferenceSet(): Promise<boolean> {
    try {
      const value = (await SecureStorage.get(BIOMETRIC_ENABLED_KEY)) as string | null
      return value !== null
    } catch (error) {
      logger.error('Failed to read biometric preference', error)
      return false
    }
  },
}
